import { Configuration } from '~/core/configuration/configuration.type';
import { GeneralFilter } from '~/core/features/filtering/GeneralFilter';
import { CancelAllFiltersPayload } from '~/core/state/actions';
import { State } from '../types/state';

const cancelAllFilters = (state: State, config: Configuration, payload: CancelAllFiltersPayload): State => {
    const filter = new GeneralFilter();

    return {
        ...state,
        controls: state.controls.map((querySet) => {
            if (querySet.querySet.identifier !== payload.querySetIdentifier) {
                return querySet;
            }
            return {
                ...querySet,
                filters: querySet.filters.map((filterControls) => {
                    // number filter needs its initial values (configuration) in order to be cancelled properly
                    if (filterControls.type === 'integer' || filterControls.type === 'float') {
                        const filterConfig = config.layout.search
                            .find((confQuerySet) => confQuerySet.querySet.identifier === querySet.querySet.identifier)
                            ?.filters.find((confFilter) => confFilter.identifier === filterControls.identifier);
                        return filter.cancelFilter(filterControls, {}, filterConfig);
                    }
                    return filter.cancelFilter(filterControls, { cancelAll: true });
                }),
            };
        }),
    };
};

export default cancelAllFilters;
